import React, { useState } from 'react'
import { FileTextOutlined, PlusOutlined } from '@ant-design/icons'
import { Button, List, Modal, Input, DatePicker } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { getAddendumUrl } from 'states/modules/documentDetail'
import { array, number } from 'prop-types'
import PdfCarouselModal from '~/components/PdfCarouselModal'
import FileUpload from '~/components/fileUpload'
import api from 'services/api'
import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom'

const AddendumView = ({ document_id, addendum = [] }) => {
	const dispatch = useDispatch()
	const addendumUrls = useSelector(
		(state) => state.documentDetail.addendumUrls.data
	)
	const loadingAddendum = useSelector(
		(state) => state.documentDetail.addendumUrls.loading
	)
	const history = useHistory()

	const [visible, setVisible] = useState(false)
	const [currentIndex, setCurrentIndex] = useState(0)
	const [addModalVisible, setAddModalVisible] = useState(false)
	const [newAddendumName, setNewAddendumName] = useState('')
	const [newAddendumDate, setNewAddendumDate] = useState(null)
	const [uploadedFile, setUploadedFile] = useState(null)
	const [uploading, setUploading] = useState(false)

	const openModal = (index) => {
		dispatch(getAddendumUrl({ id: document_id }))
		setCurrentIndex(index)
		setVisible(true)
	}

	const openAddModal = () => {
		resetAddendumForm()
		setAddModalVisible(true)
	}

	const resetAddendumForm = () => {
		setNewAddendumName('')
		setNewAddendumDate(null)
		setUploadedFile(null)
		setUploading(false)
	}

	const handleFileChange = (files) => {
		if (files && files.length > 0) {
			setUploadedFile(files[0])
			setUploading(false)
		} else {
			setUploadedFile(null)
		}
	}

	const handleAddAddendum = async () => {
		if (!uploadedFile || !newAddendumName || !newAddendumDate) return

		const payload = {
			name: newAddendumName,
			filename: uploadedFile.name,
			date: dayjs(newAddendumDate).format('DD/MM/YYYY'),
			uuid: uploadedFile.uid,
		}

		try {
			setUploading(true)
			await api.post(`/documents/${document_id}/add-addendum`, payload)
			// Atualizar lista? Pode fazer dispatch de um fetch aqui se quiser!
			setAddModalVisible(false)
			resetAddendumForm()
			history.push(`/documents/${document_id}/edit`)
		} catch (error) {
			console.error('Erro ao adicionar aditivo', error)
		} finally {
			setUploading(false)
		}
	}

	const isAddButtonDisabled =
		!newAddendumName || !newAddendumDate || !uploadedFile

	return (
		<div>
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<h3>Aditivos</h3>
				<Button type="primary" icon={<PlusOutlined />} onClick={openAddModal}>
					Adicionar
				</Button>
			</div>

			{addendum.length === 0 ? (
				<div style={{ textAlign: 'center', padding: '40px 0' }}>
					<FileTextOutlined style={{ fontSize: 40, color: '#ccc' }} />
					<p style={{ marginTop: 10, color: '#999' }}>
						Este documento ainda não possui aditivos.
					</p>
				</div>
			) : (
				<>
					<List
						itemLayout="horizontal"
						dataSource={addendum}
						locale={{ emptyText: 'Nenhum aditivo disponível.' }}
						renderItem={(item, index) => (
							<List.Item
								onClick={() => openModal(index)}
								style={{ cursor: 'pointer' }}>
								<List.Item.Meta
									avatar={<FileTextOutlined style={{ fontSize: '20px' }} />}
									title={item.name}
									description={item.data}
								/>
							</List.Item>
						)}
					/>

					<PdfCarouselModal
						isVisible={visible}
						onClose={() => setVisible(false)}
						documents={addendum}
						urls={addendumUrls}
						loading={loadingAddendum}
						initialIndex={currentIndex}
						title="Aditivos"
					/>
				</>
			)}

			<Modal
				title="Adicionar Aditivo"
				open={addModalVisible}
				onCancel={() => setAddModalVisible(false)}
				onOk={handleAddAddendum}
				okText="Adicionar"
				cancelText="Cancelar"
				okButtonProps={{
					disabled: isAddButtonDisabled || uploading,
					loading: uploading,
				}}>
				<div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
					<Input
						placeholder="Nome do Aditivo"
						value={newAddendumName}
						onChange={(e) => setNewAddendumName(e.target.value)}
					/>
					<DatePicker
						style={{ width: '100%' }}
						placeholder="Data"
						format="DD/MM/YYYY"
						value={newAddendumDate}
						onChange={(date) => setNewAddendumDate(date)}
					/>
					<FileUpload
						onChange={handleFileChange}
						multiple={false}
						folder="addendums"
					/>
				</div>
			</Modal>
		</div>
	)
}

AddendumView.propTypes = {
	addendum: array,
	document_id: number,
}

export default AddendumView
